import request from '@/utils/request'

// 保存品牌信息
export function saveBrand(data) {
  return request({
    url: '/app/brand.saveBrand',
    method: 'post',
    data
  })
}

// 更新品牌信息
export function updateBrand(data) {
  return request({
    url: '/app/brand.updateBrand',
    method: 'post',
    data
  })
}

// 删除品牌信息
export function deleteBrand(brandId) {
  return request({
    url: '/app/brand.deleteBrand',
    method: 'post',
    data: {
      brandId
    }
  })
}

// 查询品牌列表
export function listBrands(params) {
  return request({
    url: '/app/brand.listBrands',
    method: 'get',
    params
  })
}

// 查询品牌评价列表
export function listBrandEvaluations(params) {
  return request({
    url: '/app/brand.listBrandEvaluations',
    method: 'get',
    params
  })
}

// 回复品牌评价
export function replyBrandEvaluation(data) {
  return request({
    url: '/app/brand.replyBrandEvaluation',
    method: 'post',
    data
  })
}

// 删除品牌评价
export function removeBrandEvaluation(evaluationId) {
  return request({
    url: '/app/brand.removeBrandEvaluation',
    method: 'post',
    data: {
      evaluationId
    }
  })
}

// 保存员工信息
export function saveEmployee(data) {
  return request({
    url: '/app/employee.saveEmployee',
    method: 'post',
    data
  })
}

// 更新员工信息
export function updateEmployee(data) {
  return request({
    url: '/app/employee.updateEmployee',
    method: 'post',
    data
  })
}

// 查询员工列表
export function listEmployees(params) {
  return request({
    url: '/app/employee.listEmployees',
    method: 'get',
    params
  })
}